import React from "react";
import { Modal } from "reactstrap";

import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";

import AButton from "../../../common/form-fields-mui/AButton";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";

const WarningPublishedDialog = ({
  isOpen,
  setOpenWarningDialog,
  rowData,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      //   toggle={onCancel}
      style={{ width: "500px" }}
    >
      <div style={{ padding: "1.5rem" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px",
          }}
        >
          <IconButtonWrapper onClick={onCancel}>
            <CrossIcon />
          </IconButtonWrapper>
        </div>
        <div>
          <div
            style={{
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "24px",
              color: "#414141",
              marginBottom: ".6rem",
              //   padding: "10px",
            }}
          >
            There are unsaved changes on this page. First, click 'Save & Next'
            to save the whole timetable. After that, you can edit individual
            rows as needed.
          </div>
        </div>

        <div className="mt-2 d-flex align-items-center">
          <AButton
            onClick={onCancel}
            className="mt-2 button_remove_left_margin"
            variant="outline"
          >
            Cancel
          </AButton>
          <AButton
            updatedStyle={{ minWidth: "130px" }}
            onClick={() => {
              setOpenWarningDialog(false);
              onConfirm(rowData);
            }}
            className="mt-2"
            variant="danger_filled"
          >
            Confirm
          </AButton>
        </div>
      </div>
    </Modal>
  );
};

export default WarningPublishedDialog;
